import React, { useState } from "react";
import { Grid, FormControlLabel, Radio, styled, FormLabel, FormControl, RadioGroup } from "@mui/material";
import { scrutinyList } from "../data";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  columnGap: theme.spacing(2),
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  display: "flex",
}));
const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
  color: theme.palette.grey[900],
  minWidth: theme.spacing(18),
  marginBottom: 0,
}));
const StyledFormControlLabel = styled(FormControlLabel)(() => ({ margin: 0 }));
const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  columnGap: theme.spacing(2),
  alignItems: "center",
  width: "18.25vw",
  minHeight: 40,
}));

function useScrutinyProcess() {
  const [scrutinyFlow, setScrutinyFlow] = useState(Digit?.SessionStorage.get("LTP.SCRUTINY.SELECTION") || null);

  const handleScrutinyOnChange = ({ target: { value } }) => {
    Digit?.SessionStorage.set("LTP.SCRUTINY.SELECTION", value);
    setScrutinyFlow(value);
  };

  return [
    scrutinyFlow === "PDF",
    scrutinyFlow,
    () => (
      <section className="container1" style={{ marginTop: 0 }}>
        <Grid container justifyContent={"center"}>
          <Grid item xs={12} md={6}>
            {scrutinyFlow === null && (
              <StyledFormControl>
                <StyledFormLabel>
                  Scrutiny Process <span className="compulsoryField">*</span>
                </StyledFormLabel>
                <StyledRadioGroup onChange={handleScrutinyOnChange} aria-labelledby="departments-list" name="department" row>
                  {scrutinyList?.map((item) => {
                    return <StyledFormControlLabel control={<Radio />} value={item?.value} label={item?.label} key={item?.name} />;
                  })}
                </StyledRadioGroup>
              </StyledFormControl>
            )}
          </Grid>
        </Grid>
      </section>
    ),
  ];
}

export default useScrutinyProcess;
